import AddIcon from '@mui/icons-material/Add'
import ClearIcon from '@mui/icons-material/Clear'
import SearchIcon from '@mui/icons-material/Search'
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  InputBase,
  Stack,
  Typography,
  styled,
} from '@mui/material'
import { AgGridReact } from 'ag-grid-react'
import { useEffect, useRef, useState } from 'react'
import { Link as RouterLink } from 'react-router'
import ProjectsList from '../ProjectsList'

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(1)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}))

export default function ProjectsCard() {
  const gridRef = useRef<AgGridReact>(null)
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    if (gridRef.current?.api) {
      gridRef.current.api.setGridOption('quickFilterText', searchText)
    }
  }, [searchText])

  const hasSearchText = searchText !== ''
  return (
    <Card>
      <CardContent>
        <Stack direction="row" justifyContent="space-between">
          <Typography gutterBottom variant="h5">
            Active Projects
          </Typography>
          <Box
            sx={{
              border: 1,
              borderRadius: 5,
              borderColor: hasSearchText ? 'secondary.main' : 'divider',
              transition: 'border-color 500ms linear',
              bgcolor: 'background.paper',
            }}
          >
            <StyledInputBase
              placeholder="Filter..."
              inputProps={{ 'aria-label': 'search' }}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              startAdornment={<SearchIcon sx={{ ml: 1 }} />}
              endAdornment={
                <ClearIcon
                  sx={{
                    mr: 1,
                    cursor: 'pointer',
                    opacity: hasSearchText ? 1 : 0,
                    transition: 'opacity 500ms linear',
                    pointerEvents: hasSearchText ? undefined : 'none',
                  }}
                  onClick={() => setSearchText('')}
                />
              }
            />
          </Box>
          <Button
            component={RouterLink}
            to="/projects/new"
            size="small"
            variant="contained"
            color="secondary"
            startIcon={<AddIcon />}
          >
            Add Project
          </Button>
        </Stack>
      </CardContent>
      <CardMedia>
        <ProjectsList boxProps={{ sx: { height: '50vh' } }} gridProps={{ borderless: true, gridRef }} />
      </CardMedia>
      <CardActions>
        <Button component={RouterLink} to="/projects" variant="outlined">
          View All Projects
        </Button>
      </CardActions>
    </Card>
  )
}
